import CloseIcon from '@mui/icons-material/Close';
import {
  Box,
  Dialog,
  Drawer,
  IconButton,
  useMediaQuery,
  useTheme,
} from '@mui/material';

import ConfirmAddressContent, {
  ConfirmAddressContentProps,
} from './ConfirmAddressContent';
import './styles';

interface ConfirmAddressModalProps extends ConfirmAddressContentProps {
  open: boolean;
}

const ConfirmAddressModal: React.FC<ConfirmAddressModalProps> = ({
  open,
  onClose,
  onContinue,
  confirmAddress,
}) => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));

  if (isDesktop) {
    return (
      <Dialog
        open={open}
        onClose={onClose}
        maxWidth="sm"
        PaperProps={{
          className: 'confirm-address-dialog',
        }}>
        <IconButton
          aria-label="Close"
          onClick={onClose}
          className="confirm-address-close">
          <CloseIcon />
        </IconButton>
        <ConfirmAddressContent
          onClose={onClose}
          onContinue={onContinue}
          confirmAddress={confirmAddress}
        />
      </Dialog>
    );
  }

  return (
    <Drawer
      anchor="bottom"
      open={open}
      onClose={onClose}
      PaperProps={{
        className: 'confirm-address-drawer',
      }}>
      <Box className="confirm-address-handle" />
      <IconButton
        aria-label="Close"
        onClick={onClose}
        className="confirm-address-close">
        <CloseIcon />
      </IconButton>
      <ConfirmAddressContent
        onClose={onClose}
        onContinue={onContinue}
        confirmAddress={confirmAddress}
      />
    </Drawer>
  );
};

export default ConfirmAddressModal;
